import React from "react";
import { partners } from "../data";

export default function Partners() {
  return (
    <section className="partners-row">
      <div className="container">
        <div className="mu-eyebrow" style={{ color: "var(--mu-purple-700)" }}>Collaborators</div>
        <h3 className="fw-bold mb-4" style={{ fontSize: "1.5rem" }}>
          Trusted by Artists, Brands &amp; Creative Partners
        </h3>
        <div className="d-flex flex-wrap justify-content-center gap-4 gap-md-5">
          {partners.map((p, i) => (
            <span className="partner-name" key={i}>{p}</span>
          ))}
        </div>
      </div>
    </section>
  );
}
